export const createPrice = `
    mutation createPrice($input: CreatePriceInput!) {
        createPrice(input:$input) {
            id
            currency
            product
            unitAmount
            active
            nickname
            billingScheme
    }
}`;

export const updatePrice = `
    mutation updatePrice($input: UpdatePriceInput!) {
        updatePrice(input:$input){
            id
            currency
            product
            unitAmount
            active
            nickname
            billingScheme
        }
}`;

export const deletePrice = `
    mutation deletePrice($input: DeletePriceInput!) {
        deletePrice(input:$input) 
}`;
